import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    unit: [],
    client: [],
    markings: [],
    kodfito: [],
    preinfoStates: []
}

export const VocSlice = createSlice({
    name: 'voc',
    initialState,
    reducers: {
        setUnit: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.unit = action.payload
        },
        delUnit: (state) => {
            state.unit = []
        },
        setClient: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.client = action.payload
        },
        delClient: (state) => {
            state.client = []
        },
        setMarkings: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.markings = action.payload
        },
        delMarkings: (state) => {
            state.markings = []
        },
        setKodfito: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.kodfito = action.payload
        },
        delKodfito: (state) => {
            state.kodfito = []
        },
        setPreinfoStates: (state, action) => {
            state.preinfoStates = action.payload
        },
        delPreinfoStates: (state) => {
            state.preinfoStates = []
        },
    }
})

// Action creators are generated for each case reducer function
export const { setUnit, delUnit, setClient, delClient, setMarkings, delMarkings, setKodfito, delKodfito, setPreinfoStates, delPreinfoStates } = VocSlice.actions

export default VocSlice.reducer